export const tabStyles = {
  tabPanel: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
}
